const cfg = window._rma_page || {};
const { lang = {} } = cfg;

// 优化交互动画
$(document).on('click', '.act', function(e) {
  const $currentTarget = $(e.currentTarget);
  $currentTarget.find('.add').toggleClass('active');
  $currentTarget.parent().find('.more').toggleClass('active');
});

// 优化数据准备
const $firstInput = $('.sources_label label input').first();
const sourceDefault = $firstInput.val();
const $firstTab = $("#markets").find("h5").first().addClass('curr');
const storeDefault = $firstTab.attr("id");
$(`#${storeDefault}_form`).show();
$firstInput.prop('checked', true);
/**
 * Represents the store data object.
 * @typedef {Object} StoreData
 * @property {string} store - The default store.
 * @property {Object} dtc - The line items for the dtc channel.
 * @property {Object} amazon - The line items for the amazon channel.
 * @property {Object} ebay - The line items for the ebay channel.
 * @property {Object} walmart - The line items for the walmart channel.
 * @property {Object} bestbuy - The line items for the bestbuy channel.
 * @property {Object} target - The line items for the target channel.
 * @property {Object} apple - The line items for the apple channel.
 * @property {Object} other_channel - The line items for other channels.
 */

/**
 * The store data object.
 * @type {StoreData}
 */
const storeData = {
  store: storeDefault,
  dtc: { line_items: [] },
  amazon: { line_items: [] },
  ebay: { line_items: [] },
  walmart: { line_items: [] },
  bestbuy: { line_items: [] },
  target: { line_items: [] },
  apple: { line_items: [] },
  other_channel: { line_items: [] }
};
loadattaches('dtc');

/**
* 加载附件的函数
* @param store - 用于标识存储的键
*/
function loadattaches(store) {
  // 从localStorage中获取附件信息，如果没有则默认为空数组
  const attaches = JSON.parse(localStorage.getItem(`attaches_${store}`)) || [];
  // 将获取到的附件信息赋值给storeData中对应store的attaches属性
  storeData[store].attaches = attaches;
  // 获取页面中的图片上传区域DOM元素
  const attachesDom = $(`#${store}_form .images`);
  // 根据附件数量决定上传按钮的显示与隐藏，最多只能上传5个附件
  attachesDom.find('i.upBox').toggle(attaches.length < 5);
  // 遍历附件数组，为每个附件创建DOM元素并添加到页面中
  const attachesList = attaches.reduce((acc, attach) => acc + `<i class="item">${attach.url.includes('.pdf')
  ? `<span class="text">${attach.name}</span>`
  : `<span class="img" style="background-image: url('${attach.url}');"></span>`}<b class="iconfont"
  data-key="${attach.url}" data-store="${store}" onclick="deleteAttach(event)">&#xe723;</b></i>`, '');
  attachesDom.prepend(attachesList);
  // 链接中有email参数时，自动填充email
  setDefaultEmailValue();
}

function setDefaultEmailValue() {
  const hasEmailForUrl = Shopify.theme.getURLParams("email");

  if (!hasEmailForUrl) return;

  const emailValue = decodeURIComponent(hasEmailForUrl);
  for( let key in storeData) {
    if (key !== 'store') {
      $(`#${key}_form input[name="email"]`).val(emailValue);
      $(`#${key}_form input[name="email_confirm"]`).val(emailValue);
      storeData[key].email = emailValue;
      storeData[key].email_confirm = emailValue;
    }
  }
}

/**
 * Toggles the store and updates the storeData object.
 * @param {Event} event - The event object triggered by the user action.
 */
function toggleStore(event) {
  const store = event.target.id;
  storeData.store = store;
  const $clickedElement = $(event.target);
  $clickedElement.addClass('curr').siblings().removeClass('curr');
  const $storeForm = $(`#${store}_form`);
  $storeForm.show().siblings().hide();
  const $sourcesLabel = $storeForm.find('.sources_label');
  if ($sourcesLabel.length) {
    const $firstInput = $sourcesLabel.find('input[name="where_to_purchase"]').first();
    $firstInput.prop('checked', true);
    storeData[store].where_to_purchase = $firstInput.val();
  }
};

/**
 * Closes the modal by hiding it.
 */
function closeModal() {
  $('#myModal').hide();
}
/**
 * Opens a modal and sets the content.
 * @param {string} con - The content to be displayed in the modal.
 */
function openModal(con) {
  $('#myModal').show();
  $('#modal_con').html(con);
}

/**
 * Uploads an attachment file.
 * @param {Event} event - The event object triggered by the file upload.
 */
function uploadAttach(event) {
  const { files = [], dataset } = event.target;
  const { store } = dataset;
  const file = files[0];
  if (!file) return;
  if (!['image', 'pdf', 'video'].find(t => file.type.includes(t))) {
    openModal(`<p>${lang.file_format_error}</p>`);
    return;
  } 
  if (file.size > 1024 * 1024 * 10) {
    openModal(`<p>${lang.file_size_error}</p>`);
    return;
  }
  
  $('.attachSpin').addClass('active');
  
  $.ajax({
    url: '/apps/pp/.netlify/functions/upload-attachment',
    type: 'POST',
    cache: false,
    data: JSON.stringify({
      mimeType: file.type,
      fileSize: file.size,
      folder: 'eufy/rma',
    }),
    processData: false,
    contentType: 'application/json'
  }).done(result => {
    const { fields, fileUrl, url } = JSON.parse(result);
    $('.attachSpin').addClass('active');
    
    // 创建FormData对象并附加预签名的字段和文件
    const formData = new FormData();
    Object.keys(fields).forEach((key) => {
      formData.append(key, fields[key]);
    });
    formData.append('file', file);
    
    // 发起AWS S3 Presigned URL上传
    $.ajax({
      url,
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false // 确保使用multipart/form-data
    }).done(() => {
      const name = file.name;
      drawingAttach({ url: fileUrl, name }, store);
    }).always(() => { 
      $('.attachSpin').removeClass('active');
      event.target.value = ''; // 清空input
    });
  }).fail(() => $('.attachSpin').removeClass('active'));
}

/**
 * Attaches a drawing to the form.
 *
 * @param {string} attach - The attach item of the drawing.
 * @param {string} store - The store identifier.
 */
function drawingAttach(attach, store) {
  // 最多只能上传5个附件
  const { url, name } = attach;
  const imagesDom = $(`#${store}_form .images`);
  // dom插入
  const html = `<i class="item">${url.includes('.pdf')
    ? `<span class="text">${name}</span>` : `<span class="img" style="background-image: url('${url}');"></span>`}
    <b class="iconfont" data-key="${url}" data-store="${store}" onclick="deleteAttach(event)">&#xe723;</b></i>`;
  imagesDom.prepend(html);

  // 数据储存
  const data = storeData[store];
  data.attaches = [...(data.attaches || []), attach];
  storeData[store] = data;
  localStorage.setItem(`attaches_${store}`, JSON.stringify(data.attaches));

  // 上传按钮处理
  const upBox = imagesDom.children('i.upBox');
  if (imagesDom.children('i.item').length >= 5) upBox.hide();
  else upBox.show()
}

/**
 * Deletes an attachment and updates the UI accordingly.
 * @param {Event} event - The event object triggered by the delete action.
 */
function deleteAttach(event) {
  const { key, store } = event.target.dataset;
  const data = storeData[store];
  $('.attachSpin').addClass('active');
  $.ajax({
    url: `/apps/pp/.netlify/functions/delete-attachment?fileUrl=${encodeURIComponent(key)}`,
    type: 'POST',
    cache: false,
    processData: false,
    contentType: 'application/json'
  }).done(() => {
    // 最多只能上传5个附件
    const attachesDom = $(`#${store}_form .images`);
    attachesDom.find('i.upBox').css("display", "inline-block");
    $(event.target.parentNode).remove();
    const attaches = data.attaches.filter(attach => attach.url !== key);
    data.attaches = attaches;
    localStorage.setItem(`attaches_${store}`, JSON.stringify(attaches));
    storeData[store] = data;
  }).always(() => $('.attachSpin').removeClass('active'));
}

/**
 * Creates city options for a given store.
 *
 * @param {string} store - The store identifier.
 * @param {Array} data - The array of city data.
 */
function drawingStates(store, data) {
  const html = data.reduce((acc, cur) => acc + `<option value="${cur.id}">${cur.name}</option>`, '<option value=""></option>');
  $(`#${store}_form select[name='state']`).html(html);
}

/**
 * Retrieves and renders the states for a given store and value.
 * @param {string} store - The store identifier.
 * @param {string} value - The value used to retrieve the states.
 */
// 定义一个函数用于获取商店的状态
function getStates(store, value) {
  // 添加类名以激活地址旋转动画
  $('.addressSpin').addClass('active');
  // 从storeData中获取对应商店的数据
  const data = storeData[store];

  // 如果value为空，则直接绘制状态
  if (!value) {
    drawingStates(store);
  } else if (data[`state_${value}`]) {
    // 如果数据中已经有了对应的状态，则直接使用这些数据绘制状态
    drawingStates(store, data[`state_${value}`]);
  } else {
    // 如果没有对应的状态数据，则通过Ajax请求获取
    $('.addressSpin').addClass('active');
    $.ajax({
      // 设置请求头
      headers: Shopify.contentCreator.pastApi.getHeaders(),
      // 设置请求的URL
      url: `/apps/pp/rainbowbridge/rma/countries/${value}/states`,
      // 设置请求类型为GET
      type: 'GET',
    }).done(body => {
      // 请求成功后，使用返回的数据渲染城市选项
      drawingStates(store, body);
      // 将返回的数据存储起来，避免下次重复请求
      storeData[store] = { ...data, [`state_${value}`]: body };
    }).always(() => $('.addressSpin').removeClass('active')) // 请求完成后，无论成功与否，都移除地址旋转动画
  };
}

/**
 * Resets the form and clears the data for a specific store.
 *
 * @param {string} store - The name of the store.
 */
function resetForm(store) {
  const $form = $(`#${store}_form`);
  const where_to_purchase = storeData[store].where_to_purchase;
  // 表单内容清空
  $form.each((i, ele) => ele.reset());
  $form.find('.rma_items').empty();
  $form.find('select[name="state"]').empty();
  $form.find('.upload .images i.item').remove();
  $form.find(`option[value=${cfg.country}]`).removeAttr('selected');
  $form.find(`input[value="${where_to_purchase}"]`).prop('checked', true);
  storeData[store] = { line_items: [], attaches: [], where_to_purchase };
  localStorage.setItem(`attaches_${store}`, '[]');
}

/**
 * Renders the HTML for the RMA items based on the provided store and line items.
 *
 * @param {string} store - The store identifier.
 * @param {Array} line_items - The array of line items.
 */
function drawingProd(store, products) {
  const html = products.reduce((acc, item) => acc + `<div class='rma_item'>
    <p class='name'><label for='prodSelect'>
    <input data-id='${item.id}' data-store='${store}' class='prodSelect' type='checkbox' onchange="selectProd(event)">
    <span>${item.name}</span></label></p><div id="rma_item_${item.id}"></div></div>`, '');
  $(`#${store}_form .rma_items`).html(html);
}

/**
 * Renders the HTML for a specific item in the RMA form.
 *
 * @param {string} store - The store identifier.
 * @param {object} item - The item object containing information about the item.
 * @param {boolean} bool - A boolean value indicating whether to render the item or not.
 */
function drawingItem(store, item, bool) {
  const $itemContainer = $(`#${store}_form #rma_item_${item.id}`);
  if (bool) {
    let optionHtml = '';
    for (let i = item.quantity; i > 0; i--) {
      optionHtml += `<option value="${i}">${i === item.quantity ? 'All' : i}</option>`;
    }
    const html = `<div class='item col2'>
    <p class='select-normal col data-qty='${item.quantity}'>
    <span class='placeholder'>${lang.field_quantity}<i class='requiredFlag'>*</i></span>
    <select data-key='${item.id}' data-store='${store}' name='quantity' onchange="prodChange(event)">${optionHtml}</select></p>
    <p class='input-normal col'><span class='placeholder'>${lang.rma_series_no_tip}</span>
    <input data-key='${item.id}' data-store='${store}' autocomplete='nope' type='text' maxlength='200'
      name='sn' value='' onchange="prodChange(event)">
    </p></div>`;
    $itemContainer.html(html);
  } else {
    $itemContainer.empty();
  }
}

/**
 * Handles the selection of a product.
 *
 * @param {Event} event - The event object triggered by the selection.
 */

function selectProd(event) {
  const { checked, dataset } = event.target;
  const { store, id } = dataset;
  const item = storeData[store].products.find(item => item.id === id);
  if (checked) storeData[store].line_items.push(item);
  else storeData[store].line_items = storeData[store].line_items.filter(o => o.id !== item.id);
  drawingItem(store, item, checked);
}

/**
 * Handles the change event for product inputs.
 * @param {Event} event - The change event object.
 */
function prodChange(event) {
  const { name, value, dataset } = event.target;
  const { key, store } = dataset;
  const data = storeData[store];
  if (key) { // 如果输入款上有商品id
    data.line_items.map(item => item[name] = item.id === key ? value : item[name]);
  } else {
    if (!data.line_items.length) data.line_items.push({ [name]: value });
    else data.line_items[0][name] = value;
  }
  storeData[store] = data;
}

/**
* 当输入值发生变化时处理数据更新和相关逻辑
* @param {Event} event - 触发值变化的事件对象
*/
function valueChange(event) {
  // 从事件目标中解构出所需的属性
  const { name, value, dataset } = event.target;
  // 获取数据存储对象
  const { store } = dataset;
  // 对于其他字段，直接更新值
  storeData[store][name] = value;
  // 如果更改的是订单号码
  if (name === 'order_number') {
    // 设置订单为未验证状态
    storeData[store].verified = false;
    // 重绘产品图
    drawingProd(store, []);
  }
}

/**
* 当下拉菜单发生变化时处理数据和触发相关动作的函数
* @param {Event} event - 触发该函数的事件对象
*/
function selectChange(event) {
  // 从事件目标中解构出所需的属性
  const { name, value, selectedOptions, dataset } = event.target;
  // 从数据集中获取特定的存储对象
  const { store } = dataset;
  // 将选中的文本内容赋值给对应的存储对象属性
  storeData[store][`${name}_id`] = value;
  storeData[store][name] = selectedOptions[0].innerText;
  // 如果更改的是国家，则获取对应的州信息
  if (name === 'country') getStates(store, value);
}

/**
 * Verifies the order by making an AJAX request to retrieve order information.
 * @param {string} store - The store name.
 */
function verifyOrder(store) {
  const data = storeData[store];
  const order_number = (data.order_number || '').trim();
  if (!order_number) return openModal(lang.fill_order_number);
  data.verified = false;
  $('.orderSpin').addClass('active');
  $.ajax({
    headers: Shopify.contentCreator.pastApi.getHeaders(),
    url: `/apps/pp/rainbowbridge/rma/${order_number}/order_info`,
    type: 'GET',
    contentType: "application/json",
    dataType:"json"
  }).done(({ line_items = [] }) => {
    if (!line_items.length) return openModal(`<p>${lang.rma_order_error}</p>`);
    data.products = line_items.map(({ id, title, quantity, model, sn }) => ({
      id,
      name: title,
      quantity,
      model,
      sn
    }));
    data.verified = true;
    storeData[store] = data;
    drawingProd(store, data.products);
    return;
  }).fail(() => {
    data.line_items = [];
    data.products = [];
    storeData[store] = data;
    drawingProd(store, []);
  }).always(() =>$('.orderSpin').removeClass('active'));
}

/**
 * Regular expressions for RMA (Return Merchandise Authorization) fields.
 * @type {Object}
 * @property {RegExp} email - Regular expression for validating email addresses.
 * @property {RegExp} amz_orderid - Regular expression for validating Amazon order IDs.
 */
const rmaRegExp = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  amz_orderid: /^\d{3}-\d{7}-\d{7}$/
};
const isStringNull = str => typeof str === 'string' && !!str.trim();
const isEmail = val => rmaRegExp.email.test(val);
const isAmzOrderID = val => rmaRegExp.amz_orderid.test(val);

/**
 * Handles the RMA (Return Merchandise Authorization) confirmation.
 * 
 * @param {Event} event - The event object triggered by the confirmation action.
 */
function rmaConfirm(event) {
  event.preventDefault();
  const { store } = event.target.dataset;
  const data = storeData[store];
  const isDtc = store === 'dtc';
  const isAmazon = store === 'amazon';
  const isApple = store === 'apple_store';
  const errors = [];

  // contact data validation
  if (!data.email) errors.push(lang.fill_email);
  else if (!isEmail(data.email)) errors.push(lang.invalid_email);
  if (!data.email_confirm) errors.push(lang.fill_confirm_email);
  else if (data.email_confirm !== data.email) errors.push(lang.rma_email_confirm_tips);
  if (!data.first_name) errors.push(lang.fill_firstname);
  if (!data.last_name) errors.push(lang.fill_lastname);
  // order data validation
  if ((isDtc || isAmazon) && !data.order_number) errors.push(lang.fill_order_number);
  if (isDtc && data.order_number && !data.verified) errors.push(lang.rma_pls_verify_order);
  if (isAmazon && data.order_number && !isAmzOrderID(data.order_number)) errors.push(lang.rma_error_order_format);
  if (isDtc && data.order_number && data.verified && !data.line_items.length) errors.push(lang.rma_select_product);
  if (!isDtc && !(data.line_items[0] && data.line_items[0].name || '').trim()) errors.push(lang.fill_product_name);
  if (isApple && !data.purchase_country) errors.push(lang.fill_purchase_country);
  // problem info valication
  if (!isStringNull(data.issue_detail)) errors.push(lang.rma_fill_issue);
  else if (!data.issue_detail || data.issue_detail.trim().toLowerCase() === 'defective') errors.push(lang.rma_fill_defective);
  if (!isDtc && !(data.attaches && data.attaches.length)) errors.push(lang.rma_ex_fill_images);
  if (errors.length) return openModal(errors.map(item => `<p>${item}</p>`).join(''));


  // foramt form_map data
  const form_map = {};
  form_map.source = storeData.store;
  form_map.email = (data.email || '').trim();
  form_map.first_name = (data.first_name || '').trim();
  form_map.last_name = (data.last_name || '').trim();
  form_map.phone_number = (data.phone_number || '').trim();
  form_map.order_number = (data.order_number || '').trim();
  if (data.where_to_purchase) form_map.where_to_purchase = data.where_to_purchase;
  if (data.purchase_country) form_map.purchase_country = data.purchase_country;
  form_map.country = data.country || '';
  form_map.state = data.state || '';
  form_map.city = (data.city || '').trim();
  form_map.zip_code = (data.zip_code || '').trim();
  form_map.issue_detail = `${(data.issue_detail || '').trim()}${data.attaches.length
    ? `\n${data.attaches.map(item => item.url).join('\n')}` : ''}`;
  form_map.address1 = (data.address1 || '').trim();
  form_map.address2 = (data.address2 || '').trim();
  form_map.order_line_items = data.line_items;
  rmaSubmit(form_map);
}

/**
 * Submits the RMA (Return Merchandise Authorization) form.
 * @param {Object} formData - The data to be sent in the request body.
 */
function rmaSubmit(form_map) {
  const isAnnualMember = Shopify.theme.getURLParams("is_annual_member")
  $('.formSpin').addClass('formActive');
  const formData = {
    shopify_domain: Shopify.shop,
    register_source: window.location.href,
    form_map
  };
  isAnnualMember && (formData.is_annual_member = true);
  grecaptcha.ready(() => {
    grecaptcha.execute(ShopMetafields.recaptcha, { action: 'exchange' }).then((recaptcha) => {
      $.ajax({
        headers: {
          ...Shopify.contentCreator.pastApi.getHeaders(),
          'X-Region': Cookies.get('alpcEU') == '1' ? 'eu' : 'us',
          recaptcha,
          'X-Recaptcha-Sitekey': ShopMetafields.recaptcha,
        },
        url: '/apps/pp/rainbowbridge/rma/create',
        type: 'POST',
        contentType: "application/json",
        data: JSON.stringify(formData),
        processData: false,
        complete: function(res) {
          $('.formSpin').removeClass('formActive');
          if (res.status >= 200 && res.status < 400) {
            resetForm(storeData.store);
            openModal(`<p>${lang.request_success}</p>`);
          } else {
            openModal(`<p>${res.responseJSON?.error || 'error'}</p>`);
          }
        }
      });
    }, () => $('.formSpin').removeClass('formActive'));
  });
}
